import WorkingTime from './WorkingTime';

export default WorkingTime